export const inspirationUrlStateMethods = {
    getInspirationsTypeFromUrl() {
        const type = new URLSearchParams(window.location.search).get('type') || 'produkty';
        const allowed = Object.keys(
            this.bootstrap?.inspirationsTabs || {
                produkty: true,
                projektanci: true,
            }
        );

        return allowed.includes(type) ? type : 'produkty';
    },

    getListingUrl() {
        const url = new URL(window.location.href);
        const paramsToDelete = [];

        url.searchParams.forEach((value, key) => {
            if (
                key === 'sort' ||
                key === 'page' ||
                key === 'paged' ||
                key.startsWith('filters[')
            ) {
                paramsToDelete.push(key);
            }
        });

        paramsToDelete.forEach(key => url.searchParams.delete(key));

        const type = this.state.type || this.getInspirationsTypeFromUrl();
        url.searchParams.set('type', type);

        if (this.state.sort && this.state.sort !== 'popular') {
            url.searchParams.set('sort', this.state.sort);
        }

        Object.entries(this.state.filters || {}).forEach(([key, value]) => {
            if (Array.isArray(value)) {
                value.forEach(item => {
                    url.searchParams.append(`filters[${key}][]`, item);
                });
                return;
            }

            if (value) {
                url.searchParams.set(`filters[${key}]`, value);
            }
        });

        const search = url.searchParams.toString();

        if (!search) {
            return `${url.pathname}${url.hash}`;
        }

        return `${url.pathname}?${search}${url.hash}`;
    },
};
